import { Action } from '@ngrx/store';

export enum EDisplayProFleetModalActions {
  GetProFleetList = '[PRO_FLEET_MODAL] Get pro fleet list'
}

export class GetProFleetList implements Action {
  public readonly type = EDisplayProFleetModalActions.GetProFleetList;
  constructor(public visibility: boolean) {}
}

export type DisplayProFleetModalActions = GetProFleetList;
